import { createContext, useContext } from "react";

const ObjectSheetContext = createContext({
  closeSheet: () => null,
  open: false,
});

export const ObjectSheetProvider = ObjectSheetContext.Provider;

export const useObjectSheetContext = () => useContext(ObjectSheetContext);
